import { MemberResponseInterface, UpdateMemberDetailsRequestInterface } from '@careapp/angular-sdk';

export const REQUEST_SAVE_PROFILE = '[Profile][Request] Save profile';
export const RESPONSE_SUCCESS_SAVE_PROFILE = '[Profile][Response][Success] Save profile';
export const RESPONSE_FAIL_SAVE_PROFILE = '[Profile][Response][Fail] Save profile';

export const REQUEST_UPDATED_PROFILE = '[Profile][Request] Updated profile';
export const RESPONSE_SUCCESS_UPDATED_PROFILE = '[Profile][Response][Success] Updated profile';
export const RESPONSE_FAIL_UPDATED_PROFILE = '[Profile][Response][Fail] Updated profile';

export class RequestSaveProfileAction {
  readonly type = REQUEST_SAVE_PROFILE;
  constructor(public payload: UpdateMemberDetailsRequestInterface) { }
}

export class ResponseSuccessSaveProfileAction {
  readonly type = RESPONSE_SUCCESS_SAVE_PROFILE;
  constructor(public payload: MemberResponseInterface) { }
}

export class ResponseFailSaveProfileAction {
  readonly type = RESPONSE_FAIL_SAVE_PROFILE;
  constructor(public error: string) { }
}

export class RequestUpdatedProfileAction {
  readonly type = REQUEST_UPDATED_PROFILE;
}

export class ResponseSuccessUpdatedProfileAction {
  readonly type = RESPONSE_SUCCESS_UPDATED_PROFILE;
  constructor(public payload: MemberResponseInterface) { }
}

export class ResponseFailUpdatedProfileAction {
  readonly type = RESPONSE_FAIL_UPDATED_PROFILE;
  constructor(public error: string) { }
}
